// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3jX3r","content":"ManualTimeModal_content__IYUEF"};